import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  API_NOT_DEPLOYED_MSG,
  formatReindexSuccessToast,
  isSkinAssistantApiNotDeployed,
  parseReindexResponse,
  reindexSkinAssistantKnowledge,
} from "../../helper/skin_assistant_helper";
import { getAdminToken } from "../../helper/auth_helper";

export default function SkinAssistantReindexButton({ className = "" }) {
  const [loading, setLoading] = useState(false);
  const token = getAdminToken();

  const handleReindex = async () => {
    if (!token) {
      toast.error("Not authorized");
      return;
    }
    setLoading(true);
    try {
      const res = await reindexSkinAssistantKnowledge(token);
      const stats = parseReindexResponse(res);
      toast.success(formatReindexSuccessToast(stats));
    } catch (error) {
      if (isSkinAssistantApiNotDeployed(error)) {
        toast.error(API_NOT_DEPLOYED_MSG);
      } else {
        toast.error(error?.message || "Knowledge reindex failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline-primary"
      size="sm"
      className={className}
      onClick={handleReindex}
      disabled={loading || !token}
      title="Rebuild Skin Assistant knowledge embeddings from catalog content"
    >
      {loading ? (
        <>
          <Spinner animation="border" size="sm" className="me-1" />
          Reindexing…
        </>
      ) : (
        <>
          <i className="ri-refresh-line me-1" aria-hidden="true" />
          Reindex knowledge
        </>
      )}
    </Button>
  );
}
